<mat-card class="user-info-card">
  <mat-card-header class="user-info-header" *ngIf="showTitle">
    <mat-card-title class="user-info-title">
      <mat-icon class="user-icon">person</mat-icon>
      User Information
    </mat-card-title>
  </mat-card-header>

  <mat-card-content class="user-info-content">
    <div class="user-detail">
      <mat-icon class="detail-icon">email</mat-icon>
      <div class="detail-text">
        <div class="detail-label">Email</div>
        <div class="detail-value">{{ email }}</div>
      </div>
    </div>

    <mat-divider class="user-divider"></mat-divider>

    <div class="user-detail">
      <mat-icon class="detail-icon">badge</mat-icon>
      <div class="detail-text">
        <div class="detail-label">Name</div>
        <div class="detail-value">{{ name }}</div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
